import React from 'react';
import classes from '../ScoreboardTable.module.css';

const TableHeader = ({ columns = [], texts = {} }) => {
    return (
        <div className={classes.thead}>
            <div className={`${classes.headerRow} ${classes.rowFlex}`} role="row">
                {columns.map((column, index) => {
                    return (
                        <div key={column.key || index} className={`${classes.th} ${classes.tableCell} ${column.cssClass}`} role="columnheader" title={texts[column.text] || column.text || ''}>
                            {texts[column.text] || column.text || ''}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default TableHeader;
